module.exports = __webpack_public_path__ + "static/media/Logo1.8ab1ad53.png";